import { Box } from "@mui/material";
import { AskQuestionIcon } from "Components/Shared/Icons";
import { SUPPORT_BUTTON_STYLES } from "Components/Support/SupportButton";
import { Resources, useResource } from "Translations/Resources";

export const ReportButtonPreview = () => {
  const { t } = useResource();

  return (
    <Box
      component="span"
      display="inline-flex"
      alignItems="center"
      gap={1}
      bgcolor={SUPPORT_BUTTON_STYLES.backgroundColor}
      color="common.white"
      border={SUPPORT_BUTTON_STYLES.border}
      borderRadius={SUPPORT_BUTTON_STYLES.borderRadius}
      boxShadow="0px 2px 8px 0px rgba(43, 34, 51, 0.18)"
      fontSize="0.525rem"
      fontWeight={600}
      lineHeight={1}
      textTransform="uppercase"
      whiteSpace="nowrap"
      px={1.25}
      py={0.5}
      mx={0.5}
      sx={{ verticalAlign: "middle" }}
    >
      <AskQuestionIcon width={12} height={12} />
      {t(Resources.Support.ButtonLabel)}
    </Box>
  );
};
